import type { GaiaPayloadConfigs } from "@expert/shared-types";

/**
 * We are not using app config in the standalone app, so we need to inject a default gaia payload config. Currently we use the asurion config across all partners.
 *
 * @deprecated If you are thinking about using this, please use fallbackGaiaPayloadProps instead, as it handles both voice and chat channels. This was just used for standalone app which only supports voice.
 */
export const defaultGaiaPayloadConfigs: GaiaPayloadConfigs = {
    appName: "expert-assist",
    autoCompleteAppName: "expert-assist-autocomplete",
    areExperimentsEnabled: true,
};
